import React, { useState } from "react";
import {
  Button,
  Form,
  Grid,
  Message,
  Modal,
  Dropdown,
} from "semantic-ui-react";
import axios from "axios";

function EmployeeForm({ showModal, setShowModal, setCreated, schoolId }) {
  const [newEmp, setEmp] = useState({
    email: "",
    role: "",
  });
  const [errors, setErrors] = useState({
    email: false,
    role: false,
    response: { show: false, type: "success", message: "" },
  });
  // const [loadImage, setLoadImage] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAddNewEmployee = async () => {
    try {
      // if (!newEmp.firstName.trim())
      //   return setErrors({ ...errors, firstName: true });
      // if (!newEmp.lastName) return setErrors({ ...errors, lastName: true });
      if (
        !newEmp.email ||
        !new RegExp(/^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/).test(newEmp.email)
      )
        return setErrors({ ...errors, email: true });
      // if (!newEmp.phone) return setErrors({ ...errors, phone: true });
      // if (!newEmp.address) return setErrors({ ...errors, address: true });
      setLoading(true);
      console.log(newEmp.role);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/employees/${schoolId}`,
        {
          ...newEmp,
        },
        { headers: { token: localStorage.getItem("token") } }
      );
      setLoading(false);
      console.log(response);
      if (response.status === 201) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "success",
            message: "Employee successfully created!",
          },
        });
        setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
        setShowModal(false);
        setCreated(true);
        return;
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
      if (error.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 400) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 401) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 403) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 404) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.response.data.error,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  // const showPicker = () => {
  //   uploader.current.click();
  // };

  // const handlePickImage = async (event) => {
  //   const file = event.target.files[0];
  //   setLoadImage(true);
  //   const formData = new FormData();
  //   formData.append("file", file);

  //   formData.append("upload_preset", "roll_app");

  //   const options = {
  //     method: "POST",
  //     body: formData,
  //   };

  //   const results = await fetch(
  //     `${process.env.REACT_APP_CLOUDINARY_API}/image/upload`,
  //     options
  //   );
  //   const response = await results.json();

  //   setEmp({ ...newEmp, image: response ? response.secure_url : file });
  //   setLoadImage(false);
  // };

  return (
    <Modal
      open={showModal}
      centered
      dimmer="blurring"
      size="tiny"
      style={{
        position: "relative",
        height: 250,
      }}
      closeOnEscape
    >
      <Grid
        textAlign="center"
        style={{ height: "40vh" }}
        verticalAlign="middle"
      >
        <Grid.Column style={{ maxWidth: "70%" }}>
          <Modal.Header content="Add New Employee" as="h2" />
          <Modal.Content>
            {/* <Grid padded>
              <Grid.Column textAlign='center' width={16}>
                <Image
                  src={!newEmp.image ? `${defImage}` : newEmp.image}
                  width={100}
                  roundedCircle
                  className='m-3'
                />

                <input
                  hidden
                  type='file'
                  ref={uploader}
                  onChange={handlePickImage}
                />
                <Button
                  size='tiny'
                  loading={loadImage}
                  primary={newEmp.image ? true : false}
                  onClick={showPicker}
                >
                  <Icon name='camera' />
                  {!newEmp.image ? "Upload Image" : "Uploaded"}
                </Button>
              </Grid.Column>
            </Grid>
             */}
            <Message
              content={errors.response.message}
              hidden={!errors.response.show}
              positive={errors.response.type === "success"}
              negative={errors.response.type === "error"}
            />
            <Form style={{ marginBottom: 30, marginTop: 30 }}>
              {/* <Form.Input
                fluid
                icon='user'
                iconPosition='left'
                placeholder='First Name'
                error={errors.firstName}
                onChange={(e) => {
                  setEmp({ ...newEmp, firstName: e.target.value });
                  setErrors({ ...errors, firstName: false });
                }}
              /> */}
              {/* <Form.Input
                fluid
                icon='user'
                iconPosition='left'
                placeholder='Last Name'
                error={errors.lastName}
                onChange={(e) => {
                  setEmp({ ...newEmp, lastName: e.target.value });
                  setErrors({ ...errors, lastName: false });
                }}
              /> */}
              <Form.Input
                fluid
                icon="mail"
                iconPosition="left"
                placeholder="E-mail address"
                error={
                  errors.email
                    ? {
                        content: "Please enter a valid email address",
                        pointing: "below",
                      }
                    : false
                }
                onChange={(e) => {
                  setEmp({ ...newEmp, email: e.target.value });
                  setErrors({ ...errors, email: false });
                }}
              />
              {/* <Form.Input
                fluid
                icon='phone'
                iconPosition='left'
                placeholder='Phone number'
                error={errors.phone}
                onChange={(e) => {
                  setEmp({ ...newEmp, phone: e.target.value });
                  setErrors({ ...errors, phone: false });
                }}
              /> */}
              {/* <Form.Input
                fluid
                icon='map marker alternate'
                iconPosition='left'
                placeholder='Address'
                error={errors.address}
                onChange={(e) => {
                  setEmp({ ...newEmp, address: e.target.value });
                  setErrors({ ...errors, address: false });
                }}
              /> */}
              <Dropdown
                placeholder="Select employee role"
                selection
                fluid
                options={[
                  { key: "HR", text: "HR", value: "HR" },
                  {
                    key: "DOS",
                    text: "DOS",
                    value: "DOS",
                  },
                  // { key: "teacher", text: "Teacher", value: "Teacher" },
                ]}
                error={errors.role}
                onChange={(e) => {
                  setEmp({ ...newEmp, role: e.currentTarget.innerText });
                  setErrors({ ...errors, role: false });
                }}
              />
            </Form>
            <Modal.Actions>
              <Button
                negative
                content="Cancel"
                circular
                icon="close"
                labelPosition="right"
                onClick={() => setShowModal(false)}
              />
              <Button
                content="Add Employee"
                labelPosition="right"
                circular
                icon="checkmark"
                loading={loading}
                onClick={handleAddNewEmployee}
                primary
              />
            </Modal.Actions>
          </Modal.Content>
        </Grid.Column>
      </Grid>
    </Modal>
  );
}

export default EmployeeForm;
